import React from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { Form, FormCheck } from 'react-bootstrap';
import { FieldErrors, RegisterOptions } from 'react-hook-form';

import { ICreateWorkerFormData } from 'forms/worker';

interface ICreateWorkerTermsProps {
    register: (options?: RegisterOptions) => React.Ref<HTMLInputElement>;
    errors: FieldErrors<ICreateWorkerFormData>;
    disabled: boolean;
    loadRecaptcha: () => void;
}

export const CreateWorkerTerms = ({register, errors, disabled, loadRecaptcha}: ICreateWorkerTermsProps) => {
    const {t} = useTranslation();

    return (
        <div className="CreateWorker__form-section">
            <Form.Group className="mb-4 pt-3" controlId="CreateWorker__agreeToTerms">
                <Form.Check custom>
                    <FormCheck.Input
                        type="checkbox"
                        id="CreateWorker__agreeToTerms"
                        name="agreeToTerms"
                        ref={register()}
                        isInvalid={!!errors?.agreeToTerms}
                        value="yes"
                        disabled={disabled}
                        onClick={() => loadRecaptcha()}
                    />
                    <FormCheck.Label htmlFor="CreateWorker__agreeToTerms">
                        <Trans i18nKey="common.iAgreeToTheTermsAndConditions">
                            I Agree to the <a
                            href="https://pegasus.net.au/terms-conditions/"
                            target="_blank"
                            rel="noreferrer"
                        > Terms and Conditions</a>
                        </Trans>
                    </FormCheck.Label>
                </Form.Check>
                {(errors && errors.agreeToTerms) && (
                    <Form.Control.Feedback type="invalid" className="d-block">
                        {t('errors.agreeToTerms.missing', 'You must agree to the terms and conditions')}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
};
